module.exports = __webpack_public_path__ + "img/user-info-icon3.015dcde1.png";